import { useEffect, useRef, useState } from 'react';
import { useTranslation } from '@jupiter/plugin-runtime/i18n';
import { useUserModel } from '@/models';
import { useBannerModel } from './index.Model';
import { BannerReport } from './index.Report';
import { BannerInfo } from '@/api/seller/serv/oec_seller_learning_center_api';

export const useBanner = () => {
  const { t, i18n } = useTranslation();
  const { isLogin, roleType, userIdStr } = useUserModel();
  const { banners, interval, fetch: loadBanner } = useBannerModel();
  const [autoPlay, setAutoPlay] = useState(true);
  const placeholder = t('academy_homepage_banner_slogan_02');
  const slogans = t('academy_homepage_banner_slogan_01')
    .replace(placeholder, '%s')
    .split(/\n|\r\n/);
  const reportShowListRef = useRef<string[]>([]);

  const handleCarouselChange = (idx: number, _: number, isManual: boolean) => {
    if (isManual) {
      setAutoPlay(false);
    }

    const bannerInfo = banners[idx - 1];

    if (
      idx > 0 &&
      !reportShowListRef.current.includes(bannerInfo.image_url || '')
    ) {
      BannerReport.show(bannerInfo, userIdStr || '', roleType);
      reportShowListRef.current.push(bannerInfo.image_url || '');
    }
  };
  const handleBannerClick = (bannerInfo: BannerInfo) => {
    BannerReport.click(bannerInfo, userIdStr || '', roleType);
  };

  useEffect(() => {
    loadBanner();
  }, [i18n.language]);

  return {
    isLogin,
    banners,
    interval,
    placeholder,
    slogans,
    autoPlay,
    handleCarouselChange,
    handleBannerClick,
  };
};
